<nav #mainNav>
  <mat-toolbar>
    <div class="logo-wrapper hidden-d-none" [hidden]="!isExpanded && !isMobileScreen" role="presentation" [attr.aria-hidden]="!isExpanded && !isMobileScreen">
      <p class="company-name">Admin</p>
    </div>
    <button [ngClass]="{ collapsed: !isExpanded && !isMobileScreen }" class="nav-toggle" type="button"
      [attr.aria-label]="isExpanded && !isMobileScreen ? 'Collapse Menu' : isMobileScreen ? 'Close Menu' : 'Expand Menu' "
      [matRippleDisabled]="true" (click)="toggleNav($event)" mat-icon-button matRipple>
      <mat-icon>keyboard_tab</mat-icon>
    </button>
  </mat-toolbar>

  <ul class="nav-list">
    @if (showCustomerService) {
      <li class="nav-list-item" (click)="isMobileScreen && navLinkClickedOnMobile(customerServiceActive, $event)">
        <a [routerLink]="['/customerservice']" #customerServiceActive="routerLinkActive" routerLinkActive="active" ngxTippy
          [ngxTippy]="(!isExpanded && !isMobileScreen) ? 'CustomerService': null" [tippyProps]="{placement: 'right'}" tippyClassName="theme-color">
          <mat-icon class="md-18 m-r-8">admin_panel_settings</mat-icon>
          <span class="text-ellipsis" [hidden]="!isExpanded">Customer Service</span>
        </a>
      </li>
    }
    @if (showCMS) {
      <li class="nav-list-item" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
        <button class="sub-nav-btn" id="taa" type="button" ngxTippy [ngxTippy]="!isExpanded && !isMobileScreen ? 'CMS' : null"
          [tippyProps]="{ placement: 'right' }" tippyClassName="theme-color" (click)="openSubNav($event)" aria-expanded="false"
          aria-controls="sub-nav" [attr.aria-label]="subNavExpanded ? 'CMS, Collapse Sub Navigation' : 'CMS, Expand Sub Navigation'">
          <mat-icon class="md-18 m-r-8">lan</mat-icon>
          <span class="text-ellipsis" [hidden]="!isExpanded">CMS</span>
          <mat-icon class="expand" [ngClass]="{'hidden-d-none': !isExpanded}" [hidden]="!isExpanded">expand_more</mat-icon>
        </button>
        @if (showCMS) {
          <ul id="sub-nav" class="sub-nav-menu">
            <li (click)="isMobileScreen && navLinkClickedOnMobile(templatesActive, $event)">
              <a [routerLink]="['/cms/templates']" #templatesActive="routerLinkActive" routerLinkActive="active">
                <span class="text-ellipsis">Templates</span>
              </a>
            </li>
            <li (click)="isMobileScreen && navLinkClickedOnMobile(templatesActive, $event)">
              <a [routerLink]="['/cms/entries']" #templatesActive="routerLinkActive" routerLinkActive="active">
                <span class="text-ellipsis">Entries</span>
              </a>
            </li>
          </ul>
        }
      </li>
    }
  </ul>
</nav>
